<template>
  <div v-if="list.length > 0" class="mt-5">
    <div class="bg-white pr-3 pb-3 rounded">
      <div class="d-flex pt-3 px-4">
        <div class="label">{{ list[0].mes }}</div>
        <div class="value ml-3">{{ list[0].ano }}</div>
      </div>
      <div class="d-flex flex-wrap">
        <div v-for="(item, index) in list" :key="index" class="mt-3 ml-4">
          <button
            type="button"
            @click="item.passado ? false : setDia(item)"
            class="dia d-flex flex-column text-center justify-content-center align-items-center border rounded disabled"
            :class="
              item.passado
                ? 'bg-secondary'
                : item.sel
                ? 'bg-warning'
                : 'bg-white'
            "
            :disabled="item.passado ? true : false"
          >
            <span class="label mb-0">{{ item.dia }}</span>
            <span class="value">{{ item.diaSemana }}</span>
          </button>
        </div>
      </div>
    </div>
    <ModalHoras
      v-if="Object.keys(item).length !== 0"
      :item="item"
      :horas="dadosAgenda"
      :loading="loading"
      :isSave="horario"
      :tipoReserva="tipoReserva"
      @click="salvarAgenda"
      @cancelar="fecharModal"
    />
  </div>
  <div v-else>
    <div
      class="card border-0 py-5 d-flex justify-content-center align-items-center mt-4"
    >
      <h5>Nada Encontrado. 😟</h5>
    </div>
  </div>
</template>
<script>
import ModalHoras from "./ModalHoras.vue";
export default {
  name: "Calendario",
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    idAgenda: {
      type: String,
      default: "",
    },
    horarioSel: {
      type: Object,
      default: () => {},
    },
    tipoReserva: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      item: {},
      horasReservadas: [],
      dadosAgenda: [],
      loading: true,
      abreModal: false,
    };
  },
  components: {
    ModalHoras,
  },
  methods: {
    async setDia(dia) {
      this.item = dia;
      if (dia.sel) {
        this.horario = this.horarioSel;
      } else {
        this.horario = {};
      }
      await this.buscarHorariosReservados();
      this.abreModal = true;
    },
    salvarAgenda(props) {
      props.dia = this.item;
      this.$emit("click", props);
    },
    fecharModal() {
      this.item = {};
    },
    buscarHorariosReservados() {
      this.loading = true;
      this.horasReservadas = [];
      this.$http
        .get(
          "/api/Agenda/ConsultarAgenda?agendaId=" +
            this.idAgenda +
            "&inicio=" +
            this.item.date +
            " 00:00&fim=" +
            this.item.date +
            " 23:59"
        )
        .then((response) => {
          this.loading = false;
          this.dadosAgenda = response.data;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.label {
  font-weight: 300;
  font-size: 14px;
  margin-bottom: 5px;
  line-height: 1.4;
}
.value {
  font-weight: bold;
  font-size: 16px;
  text-transform: uppercase;
  color: #000;
  line-height: 1.4;
  &.value-small {
    font-size: 14px;
  }
}
.dia {
  width: 57px;
  height: 57px;
}
</style>
